import React from "react";

import * as S from "./styles";

export const Slide14: React.FC = () => {
  return (
    <S.Container>
      <S.CreditLeft>
        Coordenação de moda: <span>André Puertas</span>
        <br />
        Produção de moda: <span>Raissa Joseph</span>
        <br />
        Assistente de foto: <span>Naelson de Castro</span>
        <br />
        Tratamento de imagem: <span>Thiago Auge</span>
        <br />
        Produção executiva: <span>Isabela de Paula</span>
      </S.CreditLeft>
      <S.CreditRight>
        Mickael veste túnica, Haight, R$ 798, calça, Another Place, R$ 390,
        corrente, Skull, R$ 420, e colar, Brennheisen, R$ 790. Suyane veste
        capa, R$ 1.621, e calça, R$ 1.985, ambas Teodora Oshima, maiô, Haight,
        R$ 368, brincos, Struktura, R$ 1.150 (o par), e anel, Brennheisen, R$
        1.900.
      </S.CreditRight>
      <S.Photo />
    </S.Container>
  );
};
